const data = [
	{
		geometry: {
			type: "LineString",
			coordinates: [[-96.796856, 32.776272], [-106.487, 31.738], [-112.071, 33.451]]
		},
		cities: ["Dallas", "Ciudad Juarez", "Phoenix"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-104.991, 39.742], [-110, 37,5], [-112.071, 33.451]]
		},
		cities: ["Denver", "Phoenix"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-96.796, 32.776], [-93.763, 32.523], [-90.184, 32.298], [-81.4, 30.332]]
		},
		cities: ["Dallas", "Shreveport", "Jackson", "Jacksonville"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-104.991, 39.742],  [-102, 36], [-96.796856, 32.776272]]
		},
		cities: ["Denver", "Dallas"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-96.796856, 32.776272], [-94, 39], [-87.554, 41.739]]
		},
		cities: ["Dallas", "Chicago"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-87.554, 41.739], [-85, 41], [-81.621, 41.503]]
		},
		cities: ["Chicago", "Cleveland"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-81.621, 41.503], [-86, 39], [-86.7816, 36.1627],]
		},
		cities: ["Cleveland", "Nashville"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-81.621, 41.503], [-80, 40], [-77.487, 39.044]]
		},
		cities: ["Cleveland", "Ashburn"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-77.487, 39.044], [-78.625, 35.884], ]
		},
		cities: ["Ashburn", "Raleigh"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-78.625, 35.884], [-81, 34], [-84.387, 33.749]]
		},
		cities: ["Raleigh", "Atlanta"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-84.387, 33.749], [-84, 31], [-81.379, 28.538]]
		},
		cities: ["Atlanta", "Orlando"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-81.379, 28.538], [-81, 28], [-80.083, 26.359]]
		},
		cities: ["Orlando", "Boca Ratón"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-77.487, 39.044], [-75, 39.8], [-73.987, 40.730]]
		},
		cities: ["Ashburn", "New York"]
	},

		{
		geometry: {
			type: "LineString",
			coordinates: [[-77.487, 39.044], [-76, 40.3], [-73.987, 40.730]]
		},
		cities: ["Ashburn", "New York"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-77.386,  39.044], [-81, 36], [-81.088, 32.076]]
		},
		cities: ["Herndon", "Savannah"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-81.088, 32.076], [-81.5, 31.25], [-81.4, 30.332]]
		},
		cities: ["Savannah", "Jacksonville"]
	},


	{
		geometry: {
			type: "LineString",
			coordinates: [[-96.796, 32.776], [-95.5, 31,7], [-95.369, 29.760]]
		},
		cities: ["Dallas", "Houston"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [[-84.2803, 30.4382559], [-95.3698028, 29.7604267], [-98.230082, 26.204369]]
		},
		name: "America 5",
		cities: ["Tallahassee", "Houston", "Mcallen"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [
				[-98.230082, 26.204369],
				[-99.508898, 27.506099],
				[-98.491, 29.424],
				[-97.733, 30.266],
				[-96.796856, 32.776272]
			]
		},
		name: "America 2-g",
		cities: ["Mcallen", "Laredo", "San Antonio", "Austin"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [
				[-96.796856, 32.776272],
				[-86.7816, 36.1627],
				[-84.3879824, 33.749],
				[-84.2803, 30.4382559],
				[-82.75, 29],
				[-81.8, 26.5],
				[-80.19366, 25.77427]
			]
		},
		name: "America 2-g",
		cities: ["Dallas", "Nashville", "Atlanta", "Tallahassee", "Miami"]
	},

	{
		geometry: {
			type: "LineString",
			coordinates: [
				[-96.796856, 32.776272],
				[-90.199, 38.627],
				[-86.148, 39.791],
				[-77.487, 39.044]
			]
		},
		name: "America 2-g",
		cities: ["Dallas", "San Luis", "Indianapolis", "Ashburn"]
	},
	
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-75.5, 9.5], [-74.809, 11.012]]
		},
		name: 'America 6',
		cities: ['Cartagena', 'Barranquilla']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-74.809, 11.012], [-74.076, 4.598], [-75.5, 9.5]]
		},
		name: 'America 6',
		cities: ['Cartagena', 'Barranquilla', 'bogota', 'Cartagena']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.3515, 48.8566], [8.682, 50.111]]
		},
		name: 'Europa 1',
		cities: ['Paris', 'Frankfurt']
	},

	{
		geometry: {
			type: 'LineString',
			coordinates: [[-0.128, 51.507], [4.898, 52.375], [6.776, 51.225], [8.682, 50.111]]
		},
		name: 'Europa 3',
		cities: ['London', 'Amsterdam', 'Düsseldorf', 'Frankfurt']
	},
	{
		geometry: {
			type: 'LineString',
			coordinates: [[4.898, 52.375], [5.7, 51], [8.682, 50.111]]
		},
		name: 'Europa 3',
		cities: ['Amsterdam', 'Frankfurt']
	},
	
];
export default data;
